export default __webpack_public_path__ + "static/media/TokenMoveGreen.bf034085.png";